<template>
  <div class="question-edit-variables">
    <b-card no-body>
      <b-card-header>
        <strong>Variables</strong>
      </b-card-header>
      <draggable
        class="dragArea"
        v-model="jobQuestion.jobQuestionVariables.$model"
        @update="$emit('order-variables')"
      >
        <b-card
          no-body
          class="drag mb-1"
          v-for="(v, index) in jobQuestion.jobQuestionVariables.$each.$iter"
          :key="(v.id.$model | v.uid.$model)"
          v-bind:class="{ deleteMe: v.delete_me.$model }"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h5
              class="float-left text-left my-1"
              v-b-toggle="'var_' + (v.id.$model | v.uid.$model)"
            >
              <open-icon
                :name="
                  jobQuestion.jobQuestionVariables.$model[index].visible
                    ? 'chevron-bottom'
                    : 'chevron-right'
                "
              />
              <b-badge variant="info" class="m-1">
                {{ v.delete_me.$model ? 'x' : v.order.$model }}
              </b-badge>
              <b-form-input
                type="text"
                class="variable-label-input col-8"
                v-model="v.input_label.$model"
              >
              </b-form-input>
            </h5>
            <div class="actions my-1 float-right">
              <b-btn
                size="sm"
                variant="default"
                @click="$emit('delete-variable', v.$model)"
              >
                <open-icon name="delete" />
              </b-btn>
            </div>
          </b-card-header>

          <b-collapse
            :id="'var_' + (v.id.$model | v.uid.$model)"
            role="tabpanel"
            v-model="jobQuestion.jobQuestionVariables.$model[index].visible"
          >
            <b-card-body>
              <template
                v-if="jobQuestion.type.$model === 'MULTI_VARIABLE_SELECT_ONE'"
              >
                <b-form-group label="Short Label" label-cols="4">
                  <b-form-input type="text" v-model="v.short_label.$model" />
                </b-form-group>
                <b-row>
                  <b-col
                    class="d-flex align-item-center justify-content-center mb-3"
                  >
                    <b-form-group
                      :invalid-feedback="invalidOptionsFeedback"
                      :state="validateOptionsState(v)"
                      class="text-center"
                    >
                      <b-button
                        @click="onCreateOption(v.id.$model || v.uid.$model)"
                        variant="primary"
                        size="sm"
                      >
                        Add Option
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
                <template
                  v-for="(option, index) in v.variableOptions.$each.$iter"
                >
                  <variable-option
                    :key="(option.$model.id || option.$model.uid)"
                    :index="parseInt(index) + 1"
                    :option="option"
                    @removeOption="onRemoveOption"
                    @cancelRemoveOption="onCancelRemoveOption"
                  />
                </template>
              </template>
              <template v-else>
                <!-- variable fields -->
                <b-form-group label="Short Label" label-cols="4">
                  <b-form-input type="text" v-model="v.short_label.$model" />
                </b-form-group>

                <b-form-group
                  v-if="jobQuestion.type.$model === 'SELECT_ANY'"
                  label="Member Exclusive"
                  label-cols="4"
                  label-class="py-0"
                >
                  <b-form-checkbox
                    :checked="
                      memberExclusiveId &&
                      (memberExclusiveId === v.id.$model ||
                        memberExclusiveId === v.uid.$model)
                    "
                    @change="
                      (checked) =>
                        updateMemberExclusive(
                          checked,
                          v.id.$model || v.uid.$model
                        )
                    "
                  />
                </b-form-group>

                <b-form-group
                  v-if="jobQuestion.type.$model === 'SELECT_ANY'"
                  label="Talent Exclusive"
                  label-cols="4"
                  label-class="py-0"
                >
                  <b-form-checkbox
                    :checked="
                      talentExclusiveId &&
                      (talentExclusiveId === v.id.$model ||
                        talentExclusiveId === v.uid.$model)
                    "
                    @change="
                      (checked) =>
                        updateTalentExclusive(
                          checked,
                          v.id.$model || v.uid.$model
                        )
                    "
                  />
                </b-form-group>
                <b-form-group
                  v-if="
                    ['SELECT_ONE', 'SELECT_ANY'].includes(
                      jobQuestion.type.$model
                    )
                  "
                  label="Hidden on Talent"
                  label-cols="4"
                  label-class="py-0"
                >
                  <b-form-checkbox
                    v-model="v.is_talent_hidden.$model"
                    :value="1"
                    :unchecked-value="0"
                  />
                </b-form-group>

                <div v-if="jobQuestion.type.$model === 'SLIDER'">
                  <b-form-group label="Prefix" label-cols="4">
                    <b-form-input type="text" v-model="v.prefix.$model" />
                  </b-form-group>
                  <b-form-group label="Suffix" label-cols="4">
                    <b-form-input type="text" v-model="v.suffix.$model" />
                  </b-form-group>
                  <b-form-group label="Singular Suffix" label-cols="4">
                    <b-form-input
                      type="text"
                      v-model="v.singular_suffix.$model"
                    />
                  </b-form-group>
                  <b-form-group label="Minimum Value" label-cols="4">
                    <b-form-input type="text" v-model="v.min.$model" />
                  </b-form-group>
                  <b-form-group label="Minimum Label" label-cols="4">
                    <b-form-input v-model="v.min_label.$model" />
                  </b-form-group>
                  <b-form-group label="Maximum Value" label-cols="4">
                    <b-form-input type="number" v-model="v.max.$model" />
                  </b-form-group>
                  <b-form-group label="Maximum Label" label-cols="4">
                    <b-form-input v-model="v.max_label.$model" />
                  </b-form-group>
                  <b-form-group label="Slider Increment" label-cols="4">
                    <b-form-input
                      type="number"
                      v-model="v.step.$model"
                      min="1"
                    />
                  </b-form-group>
                </div>
              </template>
            </b-card-body>
          </b-collapse>
        </b-card>
      </draggable>
      <b-card-footer>
        <b-button
          variant="info"
          size="sm"
          class="float-right"
          @click="$emit('add-variable')"
        >
          Add Variable
        </b-button>
      </b-card-footer>
    </b-card>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import draggable from 'vuedraggable';
import { createNewVariableOption } from '@/helpers/VariableOptionHelper';
import VariableOption from '@/components/question/variable/VariableOption';

export default {
  name: 'JobQuestionEditVariables',
  components: {
    draggable,
    VariableOption,
  },
  props: {
    jobQuestion: Object,
    memberExclusiveId: {
      default: null,
      validator: (prop) => typeof prop === 'number' || prop === null,
    },
    talentExclusiveId: {
      default: null,
      validator: (prop) => typeof prop === 'number' || prop === null,
    },
  },
  computed: {
    invalidOptionsFeedback: function () {
      return 'Variable must contain at least 1 option';
    },
  },
  methods: {
    updateMemberExclusive: function (checked, vId) {
      this.$emit('update-member-exclusive', checked ? vId : null);
    },
    updateTalentExclusive: function (checked, vId) {
      this.$emit('update-talent-exclusive', checked ? vId : null);
    },
    onCreateOption: function (varId) {
      const option = createNewVariableOption(varId);
      this.$emit('add-variable-option', varId, option);
    },
    onRemoveOption: function (optionId, variableId) {
      this.$emit('remove-option', optionId, variableId);
    },
    onCancelRemoveOption: function (optionId, variableId) {
      this.$emit('cancel-remove-option', optionId, variableId);
    },
    validateOptionsState: function (variable) {
      const { $dirty, minLength, required } = variable.variableOptions;
      return $dirty ? minLength && required : null;
    }
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.variable-label-input {
  display: inline-block;
  width: 300px;
  font-weight: bold;
}
</style>
